import { ApolloError, useMutation } from '@apollo/client';
import { useToast } from '@chakra-ui/react';
import { useEffect } from 'react';
import {
  CREATE_PAGE_GROUP,
  REMOVE_PAGE_GROUP,
  UPDATE_PAGE_GROUP,
} from '../graphQL/mutations';
import { GET_PAGE_DATA } from '../graphQL/queries';

const MENSAGEM_ERRO_PADRAO = 'Tivemos um erro, tente novamente mais tarde';

/**
 * Criar, editar e excluir um grupo da página. Os erros da API já viram toast
 * aqui; `avisarErroInesperado` cobre o que não vem da API (ex.: falha antes do
 * envio), que de outra forma passaria sem aviso para o operador.
 */
export default function useMutacoesPageGroup() {
  const toast = useToast();
  const opcoes = { refetchQueries: [GET_PAGE_DATA, 'GetPageData'] };

  const [createPageGroup, { loading: criando, error: erroCriacao }] =
    useMutation(CREATE_PAGE_GROUP, opcoes);
  const [updatePageGroup, { loading: atualizando, error: erroAtualizacao }] =
    useMutation(UPDATE_PAGE_GROUP, opcoes);
  const [removePageGroup, { loading: excluindo, error: erroExclusao }] =
    useMutation(REMOVE_PAGE_GROUP, opcoes);

  useEffect(() => {
    if (erroCriacao || erroAtualizacao || erroExclusao) {
      toast({
        title: 'Opss!!',
        description:
          erroCriacao?.message ||
          erroAtualizacao?.message ||
          erroExclusao?.message ||
          MENSAGEM_ERRO_PADRAO,
        status: 'error',
        position: 'top-right',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [erroCriacao, erroAtualizacao, erroExclusao]);

  const avisarErroInesperado = (erro: unknown) => {
    if (erro instanceof ApolloError) return;
    toast({
      title: 'Opss!!',
      description: MENSAGEM_ERRO_PADRAO,
      status: 'error',
      position: 'top-right',
    });
  };

  return {
    createPageGroup,
    updatePageGroup,
    removePageGroup,
    salvando: criando || atualizando,
    excluindo,
    avisarErroInesperado,
  };
}
